import "ticketbuyer/common";
import "ticketbuyer/contact_organizer";
import "ticketbuyer/item_types";
import "ticketbuyer/redeem_items";
import "ticketbuyer/retrieve_tickets";
import "ticketbuyer/events";
import "ticketbuyer/convert_season_pass_to_subscription";
import "ticketbuyer/orders";
import "ticketbuyer/order";
import "ticketbuyer/signature";
import "ticketbuyer/refunds";
import "ticketbuyer/prestream";
import "ticketbuyer/stream";
import "ticketbuyer/entities";
import "ticketbuyer/geo_restrictions";
import "ticketbuyer/gift_cards";
import "ticketbuyer/playlist";
import "common/time_slots";
import "common/calendar";
import "ticketbuyer/time_slots";
import "ticketbuyer/subscription_items";

import LazyLoad from "vanilla-lazyload/dist/lazyload.js";

window.OrderQueueTimer = require("ticketbuyer/order/queue_timer").default;
const OrderQueueSockets = require("ticketbuyer/order/queue_sockets").default;
window.DistributeItemsButtonHandler =
  require("ticketbuyer/order/distributeItemsButtonHandler").default;
window.OrderPurchasePendingTimer =
  require("ticketbuyer/order/OrderPurchasePendingTimer").default;
window.OrderPurchasePendingSockets =
  require("ticketbuyer/order/OrderPurchasePendingSockets").default;
window.listenPendingPurchaseStatus =
  require("ticketbuyer/order/listenPendingPurchaseStatus").default;

window.initializeOrderQueueSockets = function initializeOrderQueueSockets() {
  const orderSelector = ".order-pane";
  if (orderSelector != null) {
    const orderQueueSockets = new OrderQueueSockets({
      orderSelector,
    });
    orderQueueSockets.run();
  }
};

let _lazyLoad;

window.initializeImagesLazyLoad = function () {
  console.log("initializeImagesLazyLoad");
  if (_lazyLoad) {
    _lazyLoad.destroy();
  }
  _lazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    use_native: true,
  });
};

window.reloadImagesLazyLoad = function () {
  if (_lazyLoad) {
    _lazyLoad.update();
  }
};
